import { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux'

//state
import { updateCurrentProgress } from '../../State/actions'

// utils
import * as constants from '../../Utils/constants';

// components
import QuestionHeader from '../Wizard/QuestionHeader'
import Error from '../Form/Error'

// lib
const { account: bankAccount } = require('se-bank-account');

const Account = ({
    children,
    state,
    answersState,
    total,
    totalIndex,
    currentChapterIndex,
    togglePreSign,
    progress,
    handleReset,
    ...props
}) => {

    const [tempValue, setTempValue] = useState({ PaymentBankAccountNumber: '', PaymentClearingNumber: '' })
    const [accountDetails, setAccountDetails] = useState({ PaymentBankAccountNumber: '', PaymentClearingNumber: '' })
    const [answered, setAnswered] = useState(false)

    const [valid, setValid] = useState(true)
    const [errors, setErrors] = useState({})

    const empty = Object.keys(tempValue).length === 0
    const both = tempValue.PaymentBankAccountNumber !== '' && tempValue.PaymentClearingNumber !== ''
    let clearing;
    let account;
    let answer;
    let id = 'account'

    // masking account number on post
    if (Object.keys(accountDetails).length > 0 && accountDetails && accountDetails.PaymentBankAccountNumber !== '' && accountDetails.PaymentClearingNumber !== '') {
        clearing = accountDetails.PaymentClearingNumber;
        clearing = clearing.replace(/\d{4}(\d*)/, '****$1')
        account = accountDetails.PaymentBankAccountNumber;
        account = account.replace(/\d{4}(\d*)/, '****$1')
        answer = `${clearing}-${account}`
    }

    const totalQuestions = 22
    let increment = 100 / totalQuestions

    // capture data to post back to api
    const {
        form: [formState, setFormState],
    } = {
        form: useState([]),
        ...(state || {}),
    };


    useEffect(() => {
        if (accountDetails.PaymentBankAccountNumber !== '') {
            setFormState(formState => ({ ...formState, accountDetails }))
        }
    }, [accountDetails])

    const handleChange = (event) => {
        event.persist();
        setTempValue({
            ...tempValue,
            [event.target.name]: event.target.value
        }) 

        const element = event.target

        let valid = element.validity.valid

        if (element.validity.patternMismatch) {
            element.setCustomValidity('Endast siffror är tillåtna')
        } else if (element.validity.tooShort) {
            element.setCustomValidity('För kort')
        } else if (element.validity.tooLong) {
            element.setCustomValidity('För långt')
        } else {
            element.setCustomValidity('')
        }

        let message = element.validationMessage

        setErrors({
            ...errors,
            [event.target.name]: message,
            invalidAccountNumber: ''
        })
    }

    const handleAnswered = () => {
        const isValidAccount = !!bankAccount(tempValue.PaymentClearingNumber + '-' + tempValue.PaymentBankAccountNumber);

        if (!isValidAccount) {
            setErrors({
                ...errors,
                invalidAccountNumber: 'Ogiltigt kontonummer'
            })
            return
        }

        setAnswered(true)
        setAccountDetails(tempValue)

        let newProgress = progress + 1
        props.updateProgress(newProgress * increment)

        togglePreSign(true)  
    }

    const onEdit = () => {
        setAnswered(false)
        setAccountDetails({})

        setTempValue({ PaymentBankAccountNumber: '', PaymentClearingNumber: '' }) 
        handleReset(1, id, currentChapterIndex)

        //props.updateProgress(progress * increment)
    }

    // animation
    const accountRef = useRef();
    const animationConfig = { behavior: "smooth", block: 'nearest', inline: 'start' }

    useEffect(() => {
        if (accountRef) {
            accountRef.current.scrollIntoView(animationConfig);
        }
    }, []);

    return (
        <div
            ref={accountRef}
            tabIndex={`${answered ? -1 : 0}`}
            className={`pension-wizard-block__question ${answered ? "answered" : ""}`}
            onClick={answered ? onEdit : undefined}
        >
            <div className="pension-wizard-block__question__card">
             {accountDetails.PaymentBankAccountNumber !== null &&
                    <QuestionHeader
                        showCount={true}
                        count={2}
                        total={2}
                        headline={constants.account.headline}
                        text={constants.account.text}
                        index={progress}
                        answer={answer}
                    />
                }

                <div className="pension-wizard-block__question__card__account">
                    <label
                        className="pension-wizard-block__question__card__account__label"
                        htmlFor="clearing">{constants.account.labelClearing}</label>
                    <input
                        className={`pension-wizard-block__question__card__account__input ${!valid ? "pension-wizard-block__question__card__account__input--invalid" : ""}`}
                        minLength="4"
                        maxLength="5"
                        pattern="^\d+$"
                        name="PaymentClearingNumber"
                        id="PaymentClearingNumber"
                        type="text"
                        value={tempValue.PaymentClearingNumber}
                        onChange={handleChange}
                    />
                    {errors && <Error error={errors.PaymentClearingNumber} />}

                    <label className="pension-wizard-block__question__card__account__label" htmlFor="account">{constants.account.labelAccount}</label>
                    <input
                        className={`pension-wizard-block__question__card__account__input ${!valid ? "pension-wizard-block__question__card__account__input--invalid" : ""}`}
                        minLength="7"
                        maxLength="10"
                        pattern="^\d+$"
                        name="PaymentBankAccountNumber"
                        id="PaymentBankAccountNumber"
                        type="text"
                        value={tempValue.PaymentBankAccountNumber}
                        onChange={handleChange}
                    />

                    {errors && <Error error={errors.PaymentBankAccountNumber} />}

                    {errors && <Error error={errors.invalidAccountNumber} />} 
 
                    <button
                        type="button"
                        className={`button button--green ${empty || !valid || !both ? "disabled" : ""}`}
                        disabled={empty || !valid || !both ? true : false}
                        onClick={handleAnswered}>
                        {constants.buttonText.next}
                    </button>
                </div>
            </div>
         </div>
     )
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateProgress: (payload) => dispatch(updateCurrentProgress(payload))
    };
};

export default connect(null, mapDispatchToProps)(Account);


